<template>
  <div class="cf-info-banner">
    <div class="cf-info-banner__content">
      <span
        v-if="icon"
        :class="['cf-icon', icon]"
      />

      <span class="cf-info-banner__text">
        {{ message }}
      </span>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'CfInfoBanner',

    props: {
      message: {
        type: String,
        required: true
      },

      icon: {
        type: String,
        default: null
      }
    }
  };
</script>
